import { connect } from "react-redux";
import { withTranslation } from "react-i18next";
import {
    getSupplierCategoryList,
    getListSkusFollowSupplier,
    createVinwonderTagGroupAction,
    updateVinwonderTagGroupAction,
    getVinwonderTagGroupDetail,
    deleteVinwonderTagGroupAction, 
    setVinwonderTagGroupDetail,
    setListSkusFollowSupplier,
    createVinwonderTagGroupTranslate,
    updateVinwonderTagGroupTranslate,
    deleteVinwonderTagGroupTranslate} from './../../../../../actions/vinwonderTagGroupAction'
import SupplierCategoryDetail from './detail';

const mapStateToProps = state => {
    return {
        supplierCategoryState: state.supplierCategoryReducer,
        vinwonderTagGroupState: state.vinwonderTagGroupReducer,
    }
};

const mapDispatchToProps = (dispatch) => {
    return {
        setVinwonderTagGroupDetail: (vinwonderTagGroup) => dispatch(setVinwonderTagGroupDetail(vinwonderTagGroup)),
        setListSkusFollowSupplier: (listSkus) => dispatch(setListSkusFollowSupplier(listSkus)),
        getListSuppliers: (params) => dispatch(getSupplierCategoryList(params)),
        getListSkusFollowSupplier: (supplier) => dispatch(getListSkusFollowSupplier(supplier)),
        createVinwonderTagGroupAction: (vinwonderTagGroup) => dispatch(createVinwonderTagGroupAction(vinwonderTagGroup)),
        updateVinwonderTagGroupAction: (vinwonderTagGroup, callbacks) => dispatch(updateVinwonderTagGroupAction(vinwonderTagGroup, callbacks)),
        getVinwonderTagGroupDetail: (id) => dispatch(getVinwonderTagGroupDetail(id)),
        deleteVinWonder: (vinwonderTagGroup, refreshParams) => dispatch(deleteVinwonderTagGroupAction(vinwonderTagGroup, refreshParams)),
        createVinwonderTagGroupTranslate: (vinwonderTagGroup) => dispatch(createVinwonderTagGroupTranslate(vinwonderTagGroup)),
        updateVinwonderTagGroupTranslate: (vinwonderTagGroup) => dispatch(updateVinwonderTagGroupTranslate(vinwonderTagGroup)),
        deleteVinwonderTagGroupTranslate: (vinwonderTagGroup, refreshParams) => dispatch(deleteVinwonderTagGroupTranslate(vinwonderTagGroup, refreshParams)),
    }
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(SupplierCategoryDetail));
